"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlphaSlider = void 0;
const react_1 = __importDefault(require("react"));
const ColorPicker_module_css_1 = __importDefault(require("../public/ColorPicker.module.css"));
const AlphaSlider = (props) => {
    const { color } = props;
    // Updates the alpha value from the alpha slider
    const updateColorFromAlpha = (event) => {
        if (color.colorAlphaRef && color.colorAlphaRef.current) {
            const alphaSlider = color.colorAlphaRef.current;
            let y = event.clientY - alphaSlider.getBoundingClientRect().top;
            const height = color.colorAlphaRef.current.clientHeight;
            if (y < 0)
                y = 0;
            if (y > height)
                y = height;
            color.setAlpha(parseFloat((1 - (y / height)).toFixed(2)));
            color.updateAlphaSliderCircle(y);
        }
    };
    const alphaClickHandler = (event) => {
        updateColorFromAlpha(event);
    };
    const mouseMove = (event) => {
        updateColorFromAlpha(event);
    };
    const mouseUp = (event) => {
        updateColorFromAlpha(event);
        removeEventListener("mousemove", mouseMove);
        removeEventListener("mouseup", mouseUp);
    };
    const registerMouseEvents = (event) => {
        event.preventDefault();
        color.removeInputFocus();
        addEventListener("mousemove", mouseMove);
        addEventListener("mouseup", mouseUp);
    };
    return (react_1.default.createElement("div", { ref: color.colorAlphaRef, className: ColorPicker_module_css_1.default.color_alpha, style: { background: "linear-gradient(to top, #ff000000 0%, #ff0000 100%)" }, onClick: alphaClickHandler, onMouseDown: registerMouseEvents, draggable: false, "data-cy": "ColorPickerAlphaSlider" },
        react_1.default.createElement("div", { ref: color.alphaSliderRef, className: ColorPicker_module_css_1.default.slider_bar, style: { backgroundColor: "#F00" } })));
};
exports.AlphaSlider = AlphaSlider;
